<div class="page-container">
  <app-card>
    <app-card-header>
      <app-card-title>
        {{ isEditMode() ? ('addresses.form.editTitle' | translate) : ('addresses.form.newTitle' | translate) }}
      </app-card-title>
    </app-card-header>

    <app-card-content>
      @if (loading()) {
        <div class="loading-container flex flex-column flex-align-center p-lg">
          <app-spinner />
        </div>
      } @else {
        @if (error()) {
          <div class="error-container p-md" data-testid="address-form-error">
            <p>{{ error() }}</p>
          </div>
        }

        <form id="address-form" [formGroup]="form" (ngSubmit)="save()">
          <formly-form [form]="form" [fields]="fields" [model]="model" />
        </form>
      }
    </app-card-content>

    @if (!loading()) {
      <div class="form-actions flex gap-sm flex-justify-space-between">
        <div class="flex gap-sm">
          <app-button type="submit" form="address-form" variant="filled" [disabled]="saveDisabled()" data-testid="address-save-button">
            {{ 'addresses.form.save' | translate }}
          </app-button>
          <app-button type="button" variant="outlined" (click)="onCancel()" data-testid="address-cancel-button">
            {{ 'addresses.form.cancel' | translate }}
          </app-button>
        </div>
        @if (canManageAddressDelete()) {
          <app-button type="button" variant="text" color="danger" (click)="openDelete()" [disabled]="hasInteractions()"
            [tippy]="hasInteractions() ? ('addresses.form.deleteDisabledTooltip' | translate) : null"
            data-testid="address-delete-button">
            {{ 'addresses.form.deleteButton' | translate }}
          </app-button>
        }
      </div>
    }
  </app-card>
</div>

@if (showDeleteDialog()) {
  <app-modal-dialog (backdropClick)="cancelDelete()">
    <div header>
      <div class="heading-md">{{ 'addresses.form.deleteDialogTitle' | translate }}</div>
    </div>
    <div content>
      <p class="modal-description">{{ 'addresses.form.deleteDialogDescription' | translate }}</p>
      @if (deleteError()) {
        <p class="error-container p-md" data-testid="address-delete-error">{{ deleteError() }}</p>
      }
    </div>
    <div footer>
      <app-button variant="text" (click)="cancelDelete()" [disabled]="deleting()" data-testid="cancel-delete-address-button">
        {{ 'addresses.form.cancel' | translate }}
      </app-button>
      <app-button variant="filled" color="danger" (click)="confirmDelete()" [disabled]="deleting()"
        data-testid="confirm-delete-address-button">
        {{ 'addresses.form.deleteButton' | translate }}
      </app-button>
    </div>
  </app-modal-dialog>
}
